<template>
  <Teleport to="body">
    <Transition name="fade">
      <div v-if="show" class="fixed inset-0 z-[100] flex items-center justify-center px-5">
        <div class="absolute inset-0 bg-black/50" @click="dismiss" />
        <div class="relative bg-cream rounded-2xl shadow-2xl w-full max-w-[380px] overflow-hidden">
          <!-- Header -->
          <div class="px-5 pt-5 pb-3">
            <div class="flex items-center gap-3 mb-3">
              <div class="w-11 h-11 rounded-xl bg-ink flex items-center justify-center">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#FAF3E8" stroke-width="2" stroke-linecap="round">
                  <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/>
                  <polyline points="7 10 12 15 17 10"/>
                  <line x1="12" y1="15" x2="12" y2="3"/>
                </svg>
              </div>
              <div>
                <h3 class="text-17 font-bold text-ink">Новая версия {{ updateData.version }}</h3>
                <p class="text-13 text-ink/70">Доступно обновление</p>
              </div>
            </div>
          </div>

          <!-- Changelog -->
          <div v-if="updateData.changelog" class="px-5 pb-4">
            <div class="text-12 font-semibold text-ink/70 uppercase tracking-wider mb-2">Что нового</div>
            <div class="text-14 text-ink leading-relaxed whitespace-pre-line">{{ updateData.changelog }}</div>
          </div>

          <!-- Download links -->
          <div class="px-5 pb-2 space-y-2">
            <button v-if="updateData.apk_url" @click="openUrl(apkFullUrl)"
              class="flex items-center justify-center gap-2 w-full py-3 rounded-xl bg-ink text-cream text-15 font-semibold active:bg-[#2a1a10] transition-colors">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
                <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/>
                <polyline points="7 10 12 15 17 10"/>
                <line x1="12" y1="15" x2="12" y2="3"/>
              </svg>
              Скачать APK
            </button>
            <button v-if="updateData.rustore_url" @click="openUrl(updateData.rustore_url)"
              class="flex items-center justify-center gap-2 w-full py-3 rounded-xl bg-[#E7D9C6] text-ink text-15 font-semibold active:bg-[#d9c8ae] transition-colors">
              Открыть в RuStore
            </button>
          </div>

          <!-- Dismiss -->
          <div v-if="!updateData.force" class="px-5 pt-1 pb-5">
            <button @click="dismiss"
              class="w-full py-2.5 text-14 text-ink/70 font-medium">
              Позже
            </button>
          </div>
          <div v-else class="pb-5"></div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { Capacitor } from '@capacitor/core'
import { App as CapApp } from '@capacitor/app'
import { Browser } from '@capacitor/browser'
import api from '../services/api.js'

const show = ref(false)
const updateData = ref({ version: '', changelog: '', force: false, apk_url: '', rustore_url: '' })

const apkFullUrl = computed(() => {
  const u = updateData.value.apk_url
  if (!u) return ''
  if (u.startsWith('http')) return u
  return `https://zozhnik.ru${u}`
})

function dismiss() {
  if (updateData.value.force) return
  // Remember dismissed version
  localStorage.setItem('zoya-update-dismissed', updateData.value.version)
  show.value = false
}

function openUrl(url) {
  if (!url) return
  Browser.open({ url })
}

onMounted(async () => {
  // Only check on native Android platform
  if (!Capacitor.isNativePlatform()) return
  if (Capacitor.getPlatform() !== 'android') return

  try {
    const info = await CapApp.getInfo()
    const currentVersion = info.version // e.g. "1.1.132"

    const { data } = await api.get('/app/check-update', {
      params: { version: currentVersion, platform: 'android' }
    })

    if (!data.update) return

    // For non-forced updates, check if user already dismissed this version
    if (!data.force) {
      const dismissed = localStorage.getItem('zoya-update-dismissed')
      if (dismissed === data.version) return
    }

    updateData.value = data
    show.value = true
  } catch (err) {
    // Silent — don't block app usage on update check failure
    console.error('Update check error:', err)
  }
})
</script>

<style scoped>
.fade-enter-active, .fade-leave-active { transition: opacity 0.2s ease; }
.fade-enter-from, .fade-leave-to { opacity: 0; }
</style>
